import { render } from "./LabelsDrawForm.vue?vue&type=template&id=cf0b38e2"
import script from "./LabelsDrawForm.vue?vue&type=script&lang=js"
export * from "./LabelsDrawForm.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__